import Loadable from 'react-loadable';

import LoadableLoadingPage from 'pages/LoadableLoadingPage';

export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "LoginPageContainer" */
      './LoginPageContainer'
    ),
  loading: LoadableLoadingPage,
});
